// @ts-nocheck 77813613
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['add_section_label_sharebuttons'],
      sections: [addPanel.sections.getSections().developer.shareButtonsSection],
    };
  },
};
